"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Buttons = void 0;
var React = require("react");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var Buttons = function (props) { return (React.createElement(sok_ui_1.Footer, { className: 'buttons' },
    React.createElement("div", { className: 'left' }, props.uploading && (React.createElement(sok_ui_1.Button, { key: 'hide', className: 'upload-selected-files-hide', color: 'dark-blue', size: 'large', text: (0, translation_1.getLocalization)('userfront/project/files/genericFileUploadModal/buttons/hide'), onClick: props.toggleModalStatus }))),
    React.createElement("div", { className: 'right' }, !props.uploading ? (React.createElement(sok_ui_1.Button, { key: 'start-upload', className: 'upload-selected-files', color: 'dark-green', size: 'large', text: (0, translation_1.getLocalization)('userfront/project/files/genericFileUploadModal/buttons/upload'), disabled: !props.canUpload, onClick: function (e) {
            var elem = e.target
                ? e.target
                : null;
            while (elem) {
                if (elem.className.includes('upload-selected-files')) {
                    elem && elem.classList.add('disabled');
                    break;
                }
                elem = elem.parentElement;
            }
            props.startUpload();
        } })) : (React.createElement(sok_ui_1.Button, { key: 'cancel', className: 'cancel-upload', color: 'red', size: 'large', text: (0, translation_1.getLocalization)('userfront/project/files/genericFileUploadModal/buttons/cancel'), onClick: props.cancelUpload }))))); };
exports.Buttons = Buttons;
